export default function AutorizatiiPage() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-xl font-bold mt-8 mb-4">Autorizații</h2>
        <p>
            <b>Autorizația sanitară</b> a fost suspendată pe motivul schimbării denumirii 
            unității de învățământ, în prezent derulăm procedura pentru obținerea autorizației.
        </p>
        <p>
           Documente privind <b>securitatea la incendiu</b>: Liceul Tehnologic ”Dr. F. Ulmeanu” Ulmeni, Grădinița cu Program Prelungit Ulmeni și Școala Primară Mânău sunt  în curs de autorizare.
        </p>
        <p>
            Grădinița cu Program Normal Someș – Uileac nu face obiectul autorizării la incendiu .
        </p>
      </main>
    </div>
  );
}
